// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b8-3";
export var contentContainer = "_b8-0";
export var editorContainer = "_b8-1";
export var quillInputForm = "_b8-2";
export var zoneDivider = "_b8-4";